<template>
  <nav class="mobile-nav">
    <router-link
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      class="mobile-nav__item"
      active-class="is-active"
    >
      <span class="mobile-nav__icon">
        <BaseIcon :name="item.icon" />
      </span>
      <span class="mobile-nav__label">{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<script>
import BaseIcon from '../ui/BaseIcon.vue';

export default {
  name: 'MobileNav',
  components: { BaseIcon },
  data() {
    return {
      items: [
        { to: '/', label: 'Главная', icon: 'home' },
        { to: '/clubs', label: 'Поиск', icon: 'search' },
        { to: '/book', label: 'Бронь', icon: 'plus' },
        { to: '/menu', label: 'Меню', icon: 'menu' },
      ],
    };
  },
};
</script>

<style scoped src="./MobileNav.css"></style>